<template>
  <nav>
    <v-navigation-drawer v-model="mainSidebarDrawer" rail expand-on-hover @transitionend="collapseSubItems">
      <v-list density="compact" nav color="#42B0D5">
        <template v-for="(n, i) in nav">
          <v-list-item v-if="n.to && n.shouldBeVisible" :key="`${i}-a`" :to="n.to" link>
            <template #prepend>
              <mc-icon :icon="n.icon" class="mr-2"> </mc-icon>
            </template>
            <v-list-item-title class="mds mds-text--small">
              {{ n.label }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import "@maersk-global/mds-components-core/mc-icon";

export default {
  name: "NavBar",
  components: {
  },
  data() {
    return {
      mainSidebarDrawer: true,
      mini: true
    };
  },
  computed: {
    nav() {
      return [
        {
          to: "/",
          label: "Scenario",
          icon: "container",
          active: true,
          shouldBeVisible: true
          //shouldBeVisible: sessionStorage.getItem("userEmail")==='asifiqbal.sirmulla@maersk.com' || sessionStorage.getItem("userEmail")==='Rakesh.V@maersk.com' ,
        },
        {
          to: "/sep",
          label: "SEP Dashboard",
          icon: "chart-bars-vertical",
          active: true,
          shouldBeVisible: sessionStorage.getItem("userEmail")==='shrutinamra.mahapatra@maersk.com' || sessionStorage.getItem("userEmail")==='asifiqbal.sirmulla@maersk.com' || sessionStorage.getItem("userEmail")==='rakesh.V@maersk.com'
        },
        {
          to: "/utilization",
          label: "Utilization",
          icon: "module-1",
          active: true,
          shouldBeVisible: sessionStorage.getItem("userEmail")==='shrutinamra.mahapatra@maersk.com' || sessionStorage.getItem("userEmail")==='asifiqbal.sirmulla@maersk.com' || sessionStorage.getItem("userEmail")==='rakesh.V@maersk.com'
        },
        {
          to: "/bot",
          label: "Chatbot",
          icon: "comment-dots",
          active: true,
          shouldBeVisible: sessionStorage.getItem("userEmail")==='shrutinamra.mahapatra@maersk.com' || sessionStorage.getItem("userEmail")==='asifiqbal.sirmulla@maersk.com' || sessionStorage.getItem("userEmail")==='rakesh.V@maersk.com'
        },
        {
          to: "/users",
          label: "User page",
          icon: "user-plus-circle",
          active: true,
          shouldBeVisible: sessionStorage.getItem("memberRole")==='CREATOR'
        }
      ];
    }
  },
  methods: {
    collapseSubItems() {
      this.nav.map((item) => (item.active = false));
    }
  }
};
</script>
<style scoped>
.v-navigation-drawer {
  box-shadow: 1px 1px 6px 0px rgb(0 0 0 / 25%);
  position: fixed;
  top: 64px !important;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: rgb(0 36 61) !important;
}

.theme--light.v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
  font-size: 24px !important;
}

.v-application .primary--text {
  color: #42b0d5 !important;
  caret-color: #42b0d5 !important;
}

.pa-0 {
  padding: 0;
}
</style>
